// extracted by mini-css-extract-plugin
module.exports = {"container":"loader_container__kWX2b","rotate":"loader_rotate__ytM2Y","rotation":"loader_rotation__AfNIt"};